
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Cookies() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-emerald-100 text-emerald-600 rounded-full text-sm font-medium mb-4">
              Cookie管理
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-6">Cookie政策</h1>
            <p className="text-xl text-gray-600">
              了解我们如何使用Cookie来改善您的浏览体验
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 lg:p-12">
            <div className="prose prose-lg max-w-none">
              <p className="text-gray-700 leading-relaxed mb-8">
                当您访问我们的网站时，我们将使用Cookie确保我们的网站正常运行，保证您在我们的网站上获得最佳体验。这些Cookie可能与您、您的偏好或您的设备有关。这些信息通常不会用于直接识别您的身份。
              </p>

              <div className="bg-blue-50 rounded-xl p-6 mb-8 border border-blue-200">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-information-line text-blue-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-blue-800 mb-2">什么是Cookie？</h3>
                    <p className="text-blue-700 text-sm leading-relaxed">
                      Cookie是在您访问网站时存储在您设备上的小型文本文件，用于记住您的偏好设置和改善您的浏览体验。
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    Cookie的使用目的
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-settings-line text-emerald-600 mr-2"></i>
                        <h4 className="font-semibold text-gray-900">网站功能</h4>
                      </div>
                      <p className="text-gray-600 text-sm">确保网站正常运行和基本功能</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-user-line text-emerald-600 mr-2"></i>
                        <h4 className="font-semibold text-gray-900">个性化体验</h4>
                      </div>
                      <p className="text-gray-600 text-sm">记住您的偏好设置和选择</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-bar-chart-line text-emerald-600 mr-2"></i>
                        <h4 className="font-semibold text-gray-900">性能分析</h4>
                      </div>
                      <p className="text-gray-600 text-sm">分析网站使用情况，改善性能</p>
                    </div>
                    <div className="bg-gray-50 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <i className="ri-shield-check-line text-emerald-600 mr-2"></i>
                        <h4 className="font-semibold text-gray-900">安全保护</h4>
                      </div>
                      <p className="text-gray-600 text-sm">保护网站和用户免受安全威胁</p>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    您的选择权利
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    我们尊重您的个人信息权益，您可以选择禁用某些类型的Cookie，但是，阻止某些类型的Cookie可能会影响您的网站使用体验以及我们能够为您提供的服务。
                  </p>
                  <div className="bg-yellow-50 rounded-lg p-4 border border-yellow-200">
                    <div className="flex items-start">
                      <i className="ri-alert-line text-yellow-600 mr-2 mt-1"></i>
                      <p className="text-yellow-800 text-sm">
                        <strong>注意：</strong>禁用某些Cookie可能会影响网站的正常功能和您的用户体验。
                      </p>
                    </div>
                  </div>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    Cookie偏好记录
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    我们将使用Cookie来记录您在我们的Cookie隐私管理器中所做的选择。这将产生以下几方面的后果：
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <span className="text-gray-700">如果您删除了您的Cookie，再次访问我们网站时，则需要再次告知我们您的偏好。</span>
                    </li>
                    <li className="flex items-start">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <span className="text-gray-700">如果您使用不同的设备或浏览器访问我们的网站时，则需要再次告知我们您的偏好。</span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                    <span className="w-8 h-8 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                    如何管理Cookie
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-lg p-4 border border-emerald-200">
                      <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-3">
                        <i className="ri-settings-3-line text-emerald-600 text-xl"></i>
                      </div>
                      <h4 className="font-semibold text-gray-900 mb-2">浏览器设置</h4>
                      <p className="text-gray-600 text-sm">在浏览器设置中管理Cookie偏好</p>
                    </div>
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200">
                      <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-3">
                        <i className="ri-delete-bin-line text-blue-600 text-xl"></i>
                      </div>
                      <h4 className="font-semibold text-gray-900 mb-2">清除Cookie</h4>
                      <p className="text-gray-600 text-sm">随时删除已存储的Cookie</p>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-4 border border-purple-200">
                      <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-3">
                        <i className="ri-eye-off-line text-purple-600 text-xl"></i>
                      </div>
                      <h4 className="font-semibold text-gray-900 mb-2">隐私模式</h4>
                      <p className="text-gray-600 text-sm">使用无痕浏览模式访问</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-emerald-50 rounded-xl border border-emerald-200">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-emerald-100 rounded-full flex items-center justify-center mr-3 mt-1">
                    <i className="ri-customer-service-line text-emerald-600 text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-emerald-800 mb-2">需要帮助？</h3>
                    <p className="text-emerald-700 text-sm leading-relaxed">
                      如果您对我们的Cookie政策有任何疑问，请随时通过我们的联系方式与我们联系。我们很乐意为您提供帮助。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 text-center">
                <p className="text-gray-500 text-sm">
                  最后更新时间：{new Date().toLocaleDateString('zh-CN')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
